export default __webpack_public_path__ + "static/media/na.e878a78e.jpg";